module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTOmrTOeqSuipSuu0Xuq3Zt+jSOqwVuWpSeiqSumqSuiqSv////z16Pz06J7n/zkAAAALdFJOUwDfYLCQaBDvUIDPDOBxBQAAAIJJREFUGNNjYMAH2IKldxnBOOG7gUAIwmbZDQYTwBxvCGcLiM20GwoagBxGIL33NZAoA3K0gfSe00BiE5BjDeNsBnKkYZyNQM5uGGc3lAM2YDdUGRjsghoABiADomHKQEanwzgCQA4rTJkCkkN3InvBAeIhRRC7AuZVZemNRgl4QwYAtNRvM7/10zAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/circles/warning.png
// module id = 1360
// module chunks = 32